import { styled } from "styled-components";

const Wrapper = styled.section`
  .icon {
    margin: 0 auto;
    width: 1.5rem;
    height: 1.5rem;
    transition: var(--transition);
  }
  .lfacebook {
    color: #38519a;
  }
  .dfacebook {
    color: var(--text-color);
  }
  @media screen and (min-width: 900px) {
    .icon:hover {
      scale: 1.3;
    }
  }
`;

export default Wrapper;
